module.exports = __webpack_public_path__ + "static/media/gallery.eee3d0d2.svg";